/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, Button, DialogActions, Grid, Box } from "@material-ui/core";
import TimePicker from "../../TimePicker";
import DatePicker from "../../DatePicker";

interface Props {
	isOpen: boolean,
	onClose: React.Dispatch<React.SetStateAction<boolean>>,
}

const UpcomingAppointmentModifyModal: FunctionComponent<Props> = ({isOpen, onClose}) => {
    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            disableEnforceFocus
            aria-labelledby="upcoming-apointment-modify-title"
            aria-describedby="upcoming-apointment-modify-description"
        >
            <DialogTitle id="upcoming-apointment-modify-title">Modify your appointment with Dr. Pop up</DialogTitle>
            <DialogContent>
                <Box>
                    <DialogContentText id="upcoming-apointment-modify-description">
						You can only change the date and time. Please select your new dates/time.
                    </DialogContentText>
                    <Grid container>
                        <TimePicker />
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {onClose(false);}} color="primary">
					Cancel
                </Button>
                <Button color="primary" autoFocus>
					Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpcomingAppointmentModifyModal;
